enum AdditionalPaymentMethod {
  KNET = 'KNET',
  VisaMastercard = 'Visa/Mastercard',
}

export default AdditionalPaymentMethod;
